module.exports = {
  InsureNo: 'Номер заявки на страхование',
  PolicyNo: 'Номер страхового полиса',
  TheInsured: 'Застрахованное лицо',
  DateOfShipment: 'Дата отправления',
  PlaceOfOrigin: 'Место отправления',
  Destination: 'Место назначения',
  BillOfLoadingNo: 'Номер коносамента',
  Premium: 'Страховая премия',
  SubmissionTime: 'Время подачи',
  DeliveryTime: 'Время оформления полиса',
  DeliveryStatus: 'Статус оформления полиса',
  Operation: 'Действие',
  EditPolicy: 'Редактировать полис',
  DeletePolicy: 'Удалить полис',
  DownloadPolicy: 'Скачать полис',
  CancellationOfPolicy: 'Аннулировать полис',
  ReIssuePolicy: 'Переоформить полис',
  InvoiceNo: 'Номер счета-фактуры',
  PlaceOfOriginForSea: 'Морской порт отправления',
  PlaceOfOriginForAir: 'Аэропорт отправления',
  SeaportDestination: 'Морской порт назначения',
  AirportDestination: 'Аэропорт назначения',
  N1CompleteInsuranceInformation: '1. Заполнение информации о полисе',
  N3PreviewAndConfirm: '3. Просмотр и подтверждение',
  Insured: 'Застрахованное лицо',
  EmailRecipient: 'Получатель электронной почты',
  GoodsCategory: 'Категория груза',
  GoodsName: 'Наименование груза',
  MarksAndNumbers: 'Маркировка',
  BillOfLadingNumber: 'Номер коносамента',
  BillOfLadingDate: 'Дата коносамента',
  InvoiceNumber: 'Номер счета-фактуры',
  ContractNumber: 'Номер контракта',
  VesselVoyagevehiclePlateNumberflightNumber: 'Название судна и рейс/номер автомобиля/номер рейса',
  TransportationType: 'Тип перевозки',
  Domestic: 'Внутренняя',
  Import: 'Импорт',
  Export: 'Экспорт',
  TransportationMode: 'Способ перевозки',
  InlandTransportationTools: 'Транспортное средство для внутренних перевозок',
  PlaceOfDepartureport: 'Место отправления (порт)',
  DepartureDate: 'Дата отправления',
  TransitPlaceport: 'Место транзита (порт)',
  Destinationport: 'Место назначения (порт)',
  InlandStartingPoint: 'Место отправления внутри страны',
  TradeTerms: 'Торговые условия',
  InvoiceAmount: 'Сумма счета-фактуры',
  MainInsurance: 'Основной риск',
  LetterOfCreditConditionNumber: 'Номер условий аккредитива',
  ClaimsAgentPoint: 'Агент по урегулированию убытков',
  Insured2: 'Застрахованный:',
  PolicyHolder: 'Страхователь:',
  EndDateOfInsurance: 'Дата окончания страхования:',
  DateOfInsurance: 'Дата страхования:',
  DateOfEntry: 'Дата внесения:',
  MainClause: 'Основные условия:',
  GoodsName2: 'Наименование груза:',
  InsurancePremium: 'Страховая премия:',
  InsuranceAmounttotalLimit: 'Страховая сумма/Общий лимит:',
  FinalRate: 'Итоговая ставка %:',
  AddProportion: 'Коэффициент надбавки %:',
  InsuranceApplicationNumber: 'Номер заявки:',
  PolicyStatus: 'Статус полиса:',
  InsuranceStartDate: 'Дата начала страхования:',
  ReviewDate: 'Дата проверки:',
  UnderwritingDate: 'Дата андеррайтинга:',
  CompleteInsuranceInformation: 'Заполнение информации о полисе',
  Inquire: 'Запрос цены',
  PreviewAndConfirm: 'Предварительный просмотр и подтверждение',
  InsuranceCompleted: 'Страхование завершено',
  CancellationReason: 'Причина аннулирования',
  PolicyHolderInformation: 'Информация о страхователе',
  SameAsPolicyHolder: 'То же, что и страхователь',
  GoodsInformation: 'Информация о грузе',
  TransportationInformation: 'Информация о перевозке',
  InsuranceAmountInformation: 'Информация о страховой сумме',
  InsuranceConditions: 'Условия страхования',
  FreightInsurance: 'Страхование грузов',
  WPA: 'Страхование от повреждения водой',
  FPA: 'Страхование от всех рисков',
  AllRiskForRefrigeratedGoods: 'Страхование всех рисков по рефрижераторным перевозкам',
  RefrigeratedInsurance: 'Страхование рефрижераторных перевозок',
  OtherInformation: 'Другая информация',
  InsuranceInstructions: 'Инструкция по страхованию',
  TheInstitutionsWithTechnicalLtd: 'Страховые продукты, представленные на данной платформе, продаются страховыми организациями, а технические услуги предоставляются компанией Tokio Marine Nichido Fire Insurance (China) Co., Ltd.',
  PremiumAmount: 'Сумма страховой премии',
  ShanghaiStorageAndTransportationLtd: 'Shanghai Jingmao Sankyu Storage and Transportation Co., Ltd.',
  SuccessfullyInsured: 'Страхование успешно оформлено!',
  PolicyNumber: 'Номер полиса:',
  TemporarySave: 'Временное сохранение',
  PreviewAndContinue: 'Предварительный просмотр и продолжение',
  Back: 'Назад',
  PurchaseInsurance: 'Оформить страхование',
  Submitted: 'Отправлено',
  SavedSuccessfully: 'Временное сохранение успешно',
  PleaseNameOfTheCompany: 'Пожалуйста, укажите название компании-грузовладельца!',
  PleaseEmailSeparateMultipleSemicolons: 'Пожалуйста, укажите получателя письма! Для нескольких получателей используйте точку с запятой!',
  PleaseGeneralCategoryOfGoods: 'Пожалуйста, укажите категорию груза!',
  PleaseTheNameOfGoods: 'Пожалуйста, укажите наименование груза!',
  PleaseInTheInvoiceNumber: 'Пожалуйста, укажите номер счета-фактуры',
  TheShippingMarkCannotCharacters: 'Длина маркировки не должна превышать 3000 символов!',
  TheCannotExceed40Characters: 'Номер счёта не должен превышать 40 символов!',
  BillNumberCannotExceedCharacters: 'Номер коносамента не должен превышать 100 символов!',
  ContractCannotExceed100Characters: 'Номер контракта не должен превышать 100 символов!',
  PleaseVoyageNumberLicenseNumber: 'Введите название судна и рейс / номер автомобиля / номер рейса',
  PleaseEnterTheTransportationType: 'Введите тип перевозки',
  PleaseEnterTheTransportationMode: 'Введите способ перевозки',
  PleasePlaceOfDepartureport: 'Введите место отправления (порт)',
  PleaseEnterTheDestinationport: 'Введите место назначения (порт)',
  PleaseEnterTheDepartureDate: 'Введите дату отправления',
  PleaseEnterTheTradeTerms: 'Введите условия торговли!',
  PleaseEnterTheInvoiceAmount: 'Введите сумму счёта!',
  PleaseEnterTheInvoiceCurrency: 'Введите валюту суммы счёта',
  PleaseTheClaimAgencyPoint: 'Введите агентство по урегулированию претензий',
  PleaseAgreeToTheNotice: 'Пожалуйста, прочитайте и согласитесь с «Информационным письмом для клиентов»!',
  PolicyManagement: 'Управление полисами',
  QuickSearchPolicyNumber: 'Быстрый поиск: номер полиса',
  Cancellation: 'Аннулирование',
  TotalPremium: 'Общая страховая премия:',
  PleaseInTheCancellationReason: 'Укажите причину аннулирования',
  YouPermissionToEditPolicy: 'У вас нет прав на редактирование полиса',
  YouPermissionToDeletePolicy: 'У вас нет прав на удаление полиса',
  DeletingThePolicyRecordContinue: 'После удаления записи полиса будут очищены, продолжить?',
  Confirm: 'Подтвердить',
  InsurancePolicyNumber: 'Номер заявки на страхование',
  Deleted: 'Удалено',
  YouPermissionToCancelPolicy: 'У вас нет прав на аннулирование полиса',
  PolicyNumber2: 'Номер полиса',
  Canceled: 'Аннулировано',
  YouPermissionToReissuePolicy: 'У вас нет прав на переоформление полиса',
  YouBeforeAndCannotAgain: 'Вы уже переоформляли, повторное переоформление запрещено!',
  InsuranceInstructionsTip: 'Я внимательно прочитал(а) и согласен(на) с «Информационным письмом для клиентов», «Декларацией о страховании», «Пользовательским соглашением платформы», «Условиями страхования» и другими документами, понимаю и принимаю условия, включая положения об ответственности, исключения из страхового покрытия, ограничения по категориям грузов и страховой стоимости.',
  InsuranceAgent: 'Страховой агент',
  InsuranceCompany: 'Страховая компания',
  InvoiceCurrency: 'Валюта счёта',
  InsuranceAmount: 'Страховая сумма',
  InsuranceCurrency: 'Валюта страхования',
  PremiumCurrency: 'Валюта страховой премии',
  Rate: 'Тариф',
  Waybillno: 'Номер транспортной накладной',
  InsureOrderUser: 'Действия с заявкой на страхование',
  PolicyUser: 'Действия с полисом',
  ReconciliationUser: 'Сверка данных',
  PolicySyncStatus: 'Статус синхронизации полиса',
  PremiumSyncStatus: 'Статус синхронизации страховой премии',
  StartDate: 'Дата начала страхования',
  EndDate: 'Дата окончания страхования',
  FreightInsuranceFirstPage: 'Главная страница страхования грузов',
  LiabilityInsuranceHomepage: 'Главная страница страхования ответственности',
  LiabilityInsurance: 'Страхование ответственности',
  BillingManagement: 'Управление счетами',
  Scanning: 'Быстрый обзор',
  Specification: 'Особые примечания',
  ServiceAdvantages: 'Преимущества услуги',
  InsuranceType: 'Виды страхования',
  BillQuery: 'Проверка счета',
  InvoiceDownload: 'Скачать счет-фактуру',
  ViewPolicy: 'Просмотр страхового полиса',
  PolicyDownload: 'Скачать страховой полис',
  AddInquiryQuestionnaire: 'Добавить новый опросник для запроса цены',
  EditOrViewQuestionnaire: 'Редактировать/Просмотреть опросник',
  QuestionnaireStatus: 'Статус опросника',
  PolicyStatus2: 'Статус полиса',
  LiabilityInsuranceInquiry: 'Запрос цены на страхование ответственности экспедитора',
  InquiryForQuestionnaireContent: '*Содержание данного опросника предназначено только для запроса цены на страхование ответственности. Wohang и третьи стороны строго сохранят конфиденциальность.',
  AfterFillingQuestionnaire: '*После заполнения опросника третья сторона свяжется по указанному телефону в течение 24 часов.',
  ServiceProviderSelection: 'Выбор поставщика услуг:',
  ApplicantInformation: 'Информация о заявителе:',
  RegisteredAndBusiness: 'Регистрационное и торговое название компании (если есть):',
  InquiryQuestionnaire: 'Опросник для запроса цены',
  ServiceProviderReply: 'Ответ поставщика услуг',
  ServiceProviderReply2: 'Ответ поставщика',
  RegisteredName: 'Регистрационное название',
  RegisteredAddress: 'Регистрационный адрес',
  BusinessName: 'Торговое название',
  BusinessAddress: 'Юридический адрес',
  RecoveryTime: 'Время ответа:',
  ReplyContent: 'Содержание ответа:',
  ExistInsuranceReocordContinue: 'Для данной накладной уже есть запись о страховании. Продолжить?',
  TheInsuranceHasExist: 'Страховой полис уже оформлен, повторное страхование невозможно.',
  CreatedNewInsureForm: 'Создать новый страховой полис',
  ToViewOriginalApplication: 'Для просмотра существующего полиса перейдите в',
  Insurance: 'Страхование',
  Tab: 'Вкладка',
  EditViewInsuranceForm: 'Редактировать/Просмотреть страховой полис',
  Deductible: 'Франшиза',
  InsuranceCoverage: 'Страховое покрытие',
  SpecialInstructions: 'Особые условия',
  ClaimsService: 'Сервис по урегулированию убытков',
  ServiceProviderIntroduction: 'Описание поставщика услуг',
  SpecialCargo: 'Особые грузы',
  CargoExclusion: 'Исключенные грузы',
  SpecialAgreement: 'Особые соглашения',
  ChooseServiceProvider: 'Выбор поставщика услуг',
  ViewInsurancePolicy: 'Просмотр полиса на странице страхования',
  RememberOperationDirectly: 'Запомнить это действие для следующего прямого страхования',
  ProductValue: 'Стоимость продукта',
  Charges: 'Тарифы',
  MaximumIndemnityNorm: 'Лимит возмещения',
  SupplierResponse: 'Ответ поставщика',
  UploadedFileUnRemove: 'Загруженные файлы нельзя удалять!',
  NoCorrespondingTemplate: 'Соответствующий шаблон не найден!',
  NotAllowDeleteSubmited: 'Записи о страховании с статусом "Отправлено, полис оформлен" нельзя удалить. Пожалуйста, выберите заново!',
  OnlyFileDocAndPdf: 'Можно загружать только файлы с расширениями .doc, .docx или .pdf. Пожалуйста, выберите заново!',
  ToInsure: 'Страхование:',
  FillInsuranceInformation: 'Заполните информацию о страховании',
  ClickToDownloadTemplate: 'Нажмите, чтобы скачать шаблон, и заполните его по форме',
  DragFile: 'Перетащите файл сюда или',
  ClickToUpload: 'нажмите для загрузки'
}
